import {ArrowDownBold} from "@element-plus/icons-vue";

export default {
    components: {ArrowDownBold},
    data() {
        return {
            sysName: '',
            navselected: 'home',
            roleLevel: '',
            logoImg: "",
        };
    },
    mounted() {
        let user = JSON.parse(window.sessionStorage.getItem("user") || '{}');
        // let roles =  JSON.parse(window.sessionStorage.getItem("roles"));
        this.sysName = user.nickName;
        console.log("this.sysName")
        console.log(this.sysName);
        // default-active和 路由名称 相同时，导航栏背景高亮
        this.navselected = this.$route.name;
        this.roleLevel = user.roleLevel || '';
        // console.log(this.roleLevel);
    },
    created() {
        this.logoImg = require("@/assets/images/logo.png");
    },
    methods: {
        getNavType() {
            this.navselected = this.$store.state.adminleftnavnum;
            //store.state.adminleftnavnum里值变化的时候，设置navselected
        },
        selectItems(index) {
            this.$store.state.adminleftnavnum = index;
            //按钮选中之后设置当前的index为store里的值。
        },
        changeData(name) {
            this.$router.push({path: '/admin/' + name});
            this.$store.state.adminleftnavnum = name; //设置左侧导航2-2 active
            // 现在你可以通过name获取路由
            this.$store.state.actRouterTitle = this.$router.resolve({name: name}).meta.title; //设置左侧导航2-2 active
        },
        // 退出登录
        logout() {
            window.sessionStorage.clear();
            this.$router.push({path: '/login'});
        },
    },
    watch: {
        // 监测store.state
        '$store.state.adminleftnavnum': 'getNavType'
    }
}
